"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setIntrospectionEnabled = exports.isIntrospectionEnabled = void 0;

var _react = require("react");

var usesIntrospection = _react.PropTypes.any.__INTROSPECTION__;
/**
 * @return {boolean}
 */

var isIntrospectionEnabled = function isIntrospectionEnabled() {
  return usesIntrospection;
};
/**
 * Override for testing logic dependent on isIntrospectionEnabled()
 * @param {boolean} newUsesIntrospection
 */


exports.isIntrospectionEnabled = isIntrospectionEnabled;

var setIntrospectionEnabled = function setIntrospectionEnabled(newUsesIntrospection) {
  usesIntrospection = newUsesIntrospection;
};

exports.setIntrospectionEnabled = setIntrospectionEnabled;